export default "__VITE_ASSET__BG6949_E__"